<script>
import TextField from '@phoenix/mixins/components/form/fields/TextField';
import { useField } from '@phoenix/composables/field';
import FilledCheckmark from '@maison/components/form/fields/FilledCheckmark.vue';
import { PhxsgInput } from '@sg/src/View/Components/Atoms/Input';

export default {
  components: {
    FilledCheckmark,
    PhxsgInput,
  },

  mixins: [TextField],

  props: {
    isRevamp2026: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['focus', 'keyup'],

  setup(props) {
    return useField(props);
  },

  computed: {
    fieldClasses() {
      return [
        this.fieldClass,
        {
          input: !this.isRevamp2026,
          'input--filled': this.isFilled,
        },
      ];
    },

    inputAttrs() {
      return {
        id: this.fieldUniqueId,
        ref: this.field.id,
        type: this.htmlType,
        name: this.field.name,
        class: this.fieldClasses,
        'aria-describedby': this.ariaDescribedby,
        'aria-label': this.field.ariaLabel,
        placeholder: this.field.placeholder,
        disabled: this.field.disabled,
        autocomplete: this.field.autocomplete ? 'on' : 'off',
        autocorrect: this.field.autocorrect ? 'on' : 'off',
        inputmode: this.inputmode,
        pattern: this.pattern,
      };
    },
  },
};
</script>

<template>
  <phxsg-input
    v-if="isRevamp2026"
    v-bind="{ ...$attrs, ...inputAttrs }"
    v-model="value"
    @focus="$emit('focus', $event)"
    @keyup="$emit('keyup', $event)"
  />
  <input
    v-else
    v-bind="{ ...$attrs, ...inputAttrs }"
    v-model="value"
    @focus="$emit('focus', $event)"
    @keyup="$emit('keyup', $event)"
  />

  <filled-checkmark v-if="isFilled" />
</template>
